// USA
export const locale = {
    lang: 'en',
    data: {
        GENERAL: {
            SELECT_ALL: 'Select all',
            SEND: 'Send',
            RESET: 'Reset',
            SEND_EMAIL: 'Send Email',
            SEARCH: 'Search',
            NOT_RECORDS_FOUND: 'No records found.',
            DELETING: 'Deleting...',

            VALIDATION: {
                INVALID: '{{name}} is not valid',
                REQUIRED: '{{name}} is required',
                MIN_LENGTH: '{{name}} minimum length is {{min}}',
                AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
                NOT_FOUND: 'The requested {{name}} is not found',
                INVALID_LOGIN: 'Invalid username or password. Please try again.',
                REQUIRED_FIELD: 'Required field',
                MIN_LENGTH_FIELD: 'Minimum field length:',
                MAX_LENGTH_FIELD: 'Maximum field length:',
                INVALID_FIELD: 'Field is not valid',
                INVALID_EMAIL: 'Email is not valid',
                ONLY_NUMBERS: 'Only numbers are allowed'
            },
        },
        TRANSLATOR: {
            SELECT: 'Select your language',
        },
        MENU: {
            NEW: 'new',
            ACTIONS: 'Actions',
            CREATE_POST: 'Create New Post',
            PAGES: 'Pages',
            FEATURES: 'Features',
            APPS: 'Apps',
            DASHBOARD: 'Dashboard'
        },
        AUTH: {
            GENERAL: {
                OR: 'Or',
                SUBMIT_BUTTON: 'Submit',
                NO_ACCOUNT: 'Don\'t have an account?',
                SIGNUP_BUTTON: 'Sign Up',
                FORGOT_BUTTON: 'Forgot Password',
                BACK_BUTTON: 'Back',
                PRIVACY: 'Privacy',
                LEGAL: 'Legal',
                CONTACT: 'Contact',
                REMEMBER: 'Remember me',
                SESION_EXPIRED: 'Your session has expired'
            },
            LOGIN: {
                TITLE: 'Login Account',
                BUTTON: 'Sign In',
            },
            FORGOT: {
                TITLE: 'Forgotten Password?',
                DESC: 'Enter your email to reset your password',
                SUCCESS: 'Your account has been successfully reset.',
                WRONG_PARAM: 'The Username or Email is incorrect.'
            },
            REGISTER: {
                TITLE: 'Sign Up',
                DESC: 'Enter your details to create your account',
                SUCCESS: 'Your account has been successfully registered.'
            },
            CHANGE_PASSWORD: {
                EXPIRED: 'Your password has expired',
                EXPIRED_MESSAGE: 'Please change your password according to the requirements',
                TITLE: 'Change password',
                CURRENT: 'Current password',
                NEW: 'New password',
                RETYPE: 'Retype password',
                SUBMIT_BUTTON: 'Submit',
                CANCEL_BUTTON: 'Cancel',
                EXPIRED_LINK: 'This link is already expired or used'
            },
            RESET_PASSWORD: {
                TITLE: 'Reset your password',
                NEW: 'New password',
                RETYPE: 'Retype password',
                SUBMIT_BUTTON: 'Submit',
                CANCEL_BUTTON: 'Cancel',
            },
            INPUT: {
                EMAIL: 'Email',
                FULLNAME: 'Fullname',
                PASSWORD: 'Password',
                CONFIRM_PASSWORD: 'Confirm Password',
                USERNAME: 'Username'
            },
            VALIDATION: {
                INVALID: '{{name}} is not valid',
                REQUIRED: '{{name}} is required',
                MIN_LENGTH: '{{name}} minimum length is {{min}}',
                AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
                NOT_FOUND: 'The requested {{name}} is not found',
                INVALID_LOGIN: 'Invalid username or password. Please try again.',
                REQUIRED_FIELD: 'Required field',
                MIN_LENGTH_FIELD: 'Minimum field length:',
                MAX_LENGTH_FIELD: 'Maximum field length:',
                INVALID_FIELD: 'Field is not valid',
            }
        },
        ECOMMERCE: {
            COMMON: {
                SELECTED_RECORDS_COUNT: 'Selected records count: ',
                ALL: 'All',
                SUSPENDED: 'Suspended',
                ACTIVE: 'Active',
                FILTER: 'Filter',
                BY_STATUS: 'by Status',
                BY_TYPE: 'by Type',
                BUSINESS: 'Business',
                INDIVIDUAL: 'Individual',
                SEARCH: 'Search',
                IN_ALL_FIELDS: 'in all fields'
            },
            ECOMMERCE: 'eCommerce',
            CUSTOMERS: {
                CUSTOMERS: 'Customers',
                CUSTOMERS_LIST: 'Customers list',
                NEW_CUSTOMER: 'New Customer',
                DELETE_CUSTOMER_SIMPLE: {
                    TITLE: 'Customer Delete',
                    DESCRIPTION: 'Are you sure to permanently delete this customer?',
                    WAIT_DESCRIPTION: 'Customer is deleting...',
                    MESSAGE: 'Customer has been deleted'
                },
                DELETE_CUSTOMER_MULTY: {
                    TITLE: 'Customers Delete',
                    DESCRIPTION: 'Are you sure to permanently delete selected customers?',
                    WAIT_DESCRIPTION: 'Customers are deleting...',
                    MESSAGE: 'Selected customers have been deleted'
                },
                UPDATE_STATUS: {
                    TITLE: 'Status has been updated for selected customers',
                    MESSAGE: 'Selected customers status have successfully been updated'
                },
                EDIT: {
                    UPDATE_MESSAGE: 'Customer has been updated',
                    ADD_MESSAGE: 'Customer has been created'
                }
            }
        },
        CUSTOMER_ADDRESSES: {
            SUCCESS_UPDATE: 'The customer address has been successfully updated.',
            SUCCESS_DELETE: 'Successfully Deleted',
            SUCCESS_REGISTER: 'Successfully Registered',
            MESSAGE_REMOVE: 'Are you sure you want to delete this customer address?',
            ERROR_REGISTER: 'Error: Cannot register the customer addresses, please contact with your administrator',
            ERROR_UPDATE: 'Error: Cannot update the customer addresses, please contact with your administrator',
            ERROR_DELETE: 'Error: Cannot delete the customer addresses, please contact with your administrator'
        },
        MASTER_CODE: {
            SUCCESS_UPDATE: 'The master code has been successfully updated.',
            SUCCESS_REGISTER: 'Successfully Registered',
            ERROR_REGISTER: 'Error: Cannot register the master code, please contact with your administrator',
            ERROR_UPDATE: 'Error: Cannot update the master code, please contact with your administrator'
        },
        INBOUND_CONTROL: {
            SUCCESS_DELETE: 'Successfully Deleted',
            SUCCESS_REGISTER: 'Successfully Registered',
            MESSAGE_REMOVE: 'Are you sure you want to delete this inbound control?',
            ERROR_REGISTER: 'Error: Cannot register the inbound control, please contact with your administrator',
            ERROR_DELETE: 'Error: Cannot delete the inbound control, please contact with your administrator'
        },
        PRODUCT_MAPPING: {
            NO_SELECTED_ADD: 'You must select at least one part code from the available part codes list.',
            NO_SELECTED_REMOVE: 'You must select at least one part code from the associated part codes list.'
        },
        INVOICES: {
            VALIDATION: {
                REQUIRED_FIELD: 'Required field',
                MIN_LENGTH_FIELD: 'Minimum field length:',
                MAX_LENGTH_FIELD: 'Maximum field length:',
                INVALID_DATE_RANGE: 'Invalid date range.',
                NOT_ALLOWED_DATE_RANGE: 'Maximum date range is 30 days.',
                NOT_RECORDS_FOUND: 'No records found.',
                ONLY_NUMBERS: 'Only numbers and commas are allowed',
                PO_DIALOG_INVALID: 'Purchase order data is missing or invalid.',
            },
            UNPROCESSED: {
                DI: 'D-Cycle',
                ID: 'B-Cycle'
            },
            ADMIN: {
                ADD_DOC: {
                    WARNING_TOOLTIP: 'If unselected, customers with Invoice Document Flag \'N\' in ROSS won\'t receive this attachment',
                    WRONG_FILE_TYPE: 'Only PDF files are accepted'
                },
                VIEW_DOC: {
                    MESSAGE_REMOVE: 'Are you sure you want to delete this invoice support document?',
                }
            }
        },
        DEBITS_AND_CREDITS: {
            ERROR_NO_INVOICE: 'Invoice not found',
            MAIL: 'MAIL',
            VALIDATION: {
                INVALID_EMAIL: 'Invalid email Address.',
            }
        },
        PURCHASE_ORDERS: {
            NAME_COMPONENT: 'Create/Apply Change from PO',
            MARK_AS_PROCCESSED_SUCCESS: 'PO #{{order}} Marked as Processed',
            MARK_AS_CANCELLED_SUCCESS: 'Order #{{order}} Marked as Canceled',
			MARK_AS_RESET_SUCCESS: 'Order #{{order}} was reset',
            MARK_AS_UNPROCESSED_SUCCESS: 'Order #{{order}} Marked as Unprocessed',
            MARK_AS_PROCCESSED_FAIL: 'Error: Order #{{order}} was not marked as processed',
            MARK_AS_CANCELLED_FAIL: 'Error: Order #{{order}} was not marked as canceled',
			MARK_AS_RESET_FAIL: 'Error: Order #{{order}} was not reset',
            MARK_AS_UNPROCESSED_FAIL: 'Error: Order #{{order}} was not marked as unprocessed'
        },
        INQUIRIES: {
            CUSTOMER_STATEMENT: {
                CUSTOMER_STATEMENT: 'Customer Statement',
                SENDING_TO: 'Sending customer statement to',
                REGISTERED_EMAILS: 'Registered email(s)',
                OTHER_EMAILS: 'Other Email(s)',
                NO_MAIL_SELECTED: 'Please select or write a valid email',
                NO_EMAILS_FOUND: 'No emails found',
                DIVISION: 'Division',
                CUSTOMER: 'Customer',
                ADDRESS_CODE: 'Address Code',
                STATEMENT_DATE: 'Statement Date',
                AS_DATE: 'As of Date',
                TRANSACTION_TYPE: 'Transaction Type',
                CUSTOMER_NOT_FOUND: 'No Outstanding Balance found for Selected Criteria',
            },
            GENERAL: {
                INVOICES_PLACEHOLDER: 'Enter comma separated invoices',
				CREDIT_PLACEHOLDER: 'Enter comma separated credit notes',
                DOCUMENTS_PLACEHOLDER: 'Enter comma separated documents'
            },
            EDI_PO_DETAIL_REPORT: {
                NAME_COMPONENT: 'EDI Purchase Orders Detail Report',
                NOT_ALLOWED_DATE_RANGE: 'Maximum date range is 35 days',
                ERROR_SAVING_NOTE: 'Note was not updated. Please try again later'
            },
			               SALE_ORDER_SEARCH: {
           NAME_COMPONENT: 'Sales Order Search',
           ORDERS_PLACEHOLDER: 'Enter comma separated order numbers',
           UPLOAD_XML_TITLE: 'Upload XML File',
           ORDER_NUMBER: 'Order Number',
           CUSTOMER_NUMBER: 'Customer Number',
           CUSTOMER_NAME: 'Customer Name',
           SELECT_XML_FILE: 'Select XML File',
           CHOOSE_FILE: 'Choose File',
           UPLOAD_FILE: 'Upload File',
           INVALID_XML_FILE: 'Please select a valid XML file',
           PLEASE_SELECT_FILE: 'Please select a file to upload',
           UPLOAD_SUCCESS: 'File uploaded successfully',
           UPLOAD_ERROR: 'Error uploading file. Please try again.',
           UPLOAD_TXT_TITLE: 'Upload TXT File',
           SELECT_TXT_FILE: 'Select TXT File',
           INVALID_TXT_FILE: 'Please select a valid TXT file',
           UPLOAD_PO_CONFIRMATION_TITLE: 'Upload SPS PO Confirmation',
           SELECT_PO_CONFIRMATION_XML_FILE: 'Select SPS PO Confirmation File',
           UPLOAD_ASN_TITLE: 'Upload SPS ASN',
           SELECT_ASN_XML_FILE: 'Select SPS ASN File',
           UPLOAD_INVOICE_TITLE: 'Upload SPS Invoice',
           SELECT_INVOICE_XML_FILE: 'Select SPS Invoice File'
       },
        EDI_PO_SEARCH: {
            NAME_COMPONENT: 'EDI PO Search',
            UPLOAD_XML_TITLE: 'Upload XML File',
            ORDER_NUMBER: 'PO Number',
            CUSTOMER_NUMBER: 'Customer Number',
            CUSTOMER_NAME: 'Customer Name',
            SELECT_XML_FILE: 'Select XML File',
            CHOOSE_FILE: 'Choose File',
            UPLOAD_FILE: 'Upload File',
            INVALID_XML_FILE: 'Please select a valid XML file',
            PLEASE_SELECT_FILE: 'Please select a file to upload',
            UPLOAD_SUCCESS: 'File uploaded successfully',
            UPLOAD_ERROR: 'Error uploading file. Please try again.',
            UPLOAD_TXT_TITLE: 'Upload TXT File',
            SELECT_TXT_FILE: 'Select TXT File',
            INVALID_TXT_FILE: 'Please select a valid TXT file'
        },
        SALES_INVENTORY_DIST_REPORT: {
            NAME_COMPONENT: 'Sales Inventory Dist Report',
            TIME_FILTER_LABEL: 'Report period',
            TIME_FILTER_ARIA: 'Choose whether to filter by Ross week or by date range',
            TIME_FILTER_WEEK: 'Ross week (year + week)',
            TIME_FILTER_DATE_RANGE: 'Date range',
            PART_CODE: 'Part code',
            PART_CODE_HINT_SELECT_CLASS: 'Select at least one product class to load part codes.',
            YEAR: 'Year',
            WEEK: 'Week',
            WAREHOUSE: 'Warehouse',
            PRODUCT_CLASS: 'Product class',
            PRODUCT_GROUP: 'Product group',
            SALESPERSON: 'Salesperson',
            CUSTOMERS: 'Customers',
            YEAR_RANGE: 'Set a number between 2019 and {{maxYear}}',
            WEEK_RANGE: 'Set a number between 1 and 53',
            SUBMIT: 'Submit',
            GENERATING: 'Generating report…',
            DATE_FROM: 'From',
            DATE_TO: 'To',
            DATE_TYPE_ORDER: 'Order date',
            DATE_TYPE_SHIP: 'Ship date',
            DATE_TYPE_DELIVERY: 'Delivery date',
            TOTALS_TOP_LABEL: 'Totals (header)',
            TOTAL_MANIFEST: 'Manifest',
            TOTAL_CARRY_OVER: 'Carry over',
            TOTAL_SOLD: 'Sold',
            TOTAL_NET_AVAILABLE: 'Net available',
            LOT_NUMBER: 'Lot',
            COLUMN_LOT_NUMBER: 'LOT NUMBER',
            COLUMN_SALESPERSON: 'SALESPERSON',
            PHYSICAL_QTY: 'Physical qty',
            CARRY_OVER_QTY: 'Carry over',
            ALLOCATED_QTY: 'Allocated',
            NET_AVAILABLE_QTY: 'Net available',
            LOT_ROWS_CAPTION: 'Lot and part code detail',
            DATE_TYPE_LABEL: 'Date type for the range',
            EXPORT_EXCEL: 'Export to Excel',
            EXCEL_ROW_MANIFEST: 'Manifest',
            EXCEL_ROW_CARRY_OVER: 'Carry Over',
            EXCEL_ROW_TOTAL_SOLD: 'Total Sold',
            EXCEL_ROW_TOTAL_AVAILABLE: 'Total Available',
            EXCEL_COL_CUSTOMER: 'Customer',
            EXCEL_COL_ORDER_NUMBER: 'Order Number',
            EXCEL_COL_SALESPERSON: 'Salesperson',
            EXCEL_COL_LOAD_DATE: 'Load Date',
            EXCEL_WEEK_OF_YEAR: 'WEEK {{week}} of {{year}}',
            EXCEL_SOURCE: 'Source',
            EXCEL_NOTES_CAPTION: 'Notes',
            EXCEL_PALLETS: 'Pallets',
            EXCEL_LOADS: 'Loads',
            EXCEL_NEW_VESSEL: 'New Vessel',
            EXCEL_TOTAL_LABEL: 'TOTAL',
            EXCEL_QTY_PER_PALLET: 'QTY / PALLET',
            EXCEL_CARRY_OVER_UPPER: 'CARRY OVER',
            EXCEL_FRESH_MANIFEST_PREFIX: 'Fresh Manifest :',
            EXCEL_SUBTOTAL: 'SUBTOTAL',
            EXCEL_TOTAL_SOLD_UPPER: 'TOTAL SOLD',
            EXCEL_BALANCE_PALLETS: 'BALANCE (PALLETS)',
            EXCEL_BALANCE_LOADS: 'BALANCE (LOADS)',
            EXCEL_PCT_SOLD: '% Sold',
            EXCEL_SOLD_PCT_COL: 'SOLD %',
            EXCEL_PREV_WK_SHORT: 'Wk. {{week}}',
            EXCEL_VESSEL_LINE: 'Vessel - Week {{week}} {{name}}',
            EXCEL_HDR_SALESPERSON: 'SALESPERSON:',
            EXCEL_HDR_ACCOUNT: 'ACCOUNT:',
            EXCEL_HDR_ORDER: 'ORDER #',
            EXCEL_HDR_NOTES: 'NOTES:',
            ZERO_QTY_NO_LOTS_NOTICE:
                'For the selected filters, all part codes show zero quantities (manifest, carry over, sold and available), and there are no lots in this period. Adjust filters or verify inventory.'
        }
        },
        APPLICATIONS: {
            APPS_COMPS: {
                MESSAGE_REMOVE: 'Are you sure you want to delete this component?'
            },
            APPS: {
                MESSAGE_REMOVE: 'Are you sure you want to delete this application?'
            },
            VALIDATION: {
                REQUIRED_FIELD: 'Required field',
                MAX_LENGTH_REACHED: 'Reached maximum length',
                MIN_LENGTH_REACHED: 'Reached minimum length',
                MIN_LENGTH_FIELD: 'Minimum field length:',
                MIN_LENGTH_FIELD_CNC: 'Minimum field length:',
                MAX_LENGTH_FIELD: 'Maximum field length:',
                INVALID_DATE_RANGE: 'Invalid date range.',
                NOT_RECORDS_FOUND: 'No records found.'
            }
        },
        COMPONENTS: {
            VALIDATION: {
                REQUIRED_FIELD: 'Required field',
                MIN_LENGTH_FIELD: 'Minimum field length:',
                MAX_LENGTH_FIELD: 'Maximum field length:',
                INVALID_DATE_RANGE: 'Invalid date range.',
                NOT_RECORDS_FOUND: 'No records found.'
            }
        },
        ROLES: {
            ROLES: {
                MESSAGE_REMOVE: 'Are you sure you want to delete this rol?'
            },
            VALIDATION: {
                REQUIRED_FIELD: 'Required field',
                MIN_LENGTH_FIELD: 'Minimum field length:',
                MAX_LENGTH_FIELD: 'Maximum field length:',
                INVALID_DATE_RANGE: 'Invalid date range.',
                NOT_RECORDS_FOUND: 'No records found.'
            }
        },
        PROFILES: {
            PROFILES: {
                MESSAGE_REMOVE: 'Are you sure you want to delete this profile?'
            },

            VALIDATION: {
                REQUIRED_FIELD: 'Required field',
                MIN_LENGTH_FIELD: 'Minimum field length:',
                MAX_LENGTH_FIELD: 'Maximum field length:',
                INVALID_DATE_RANGE: 'Invalid date range.',
                NOT_RECORDS_FOUND: 'No records found.'
            }
        },
        ENTITIES: {
            MESSAGE_REMOVE: 'Are you sure you want to delete this entity?',
            ENTITY_TYPES: {
                MESSAGE_REMOVE: 'Are you sure you want to delete this entity type?'
            },
            VALIDATION: {
                REQUIRED_FIELD: 'Required field',
                MIN_LENGTH_FIELD: 'Minimum field length:',
                MAX_LENGTH_FIELD: 'Maximum field length:',
                INVALID_DATE_RANGE: 'Invalid date range.',
                NOT_RECORDS_FOUND: 'No records found.'
            }
        },
        PARAMETERS: {
            MESSAGE_REMOVE: 'Are you sure you want to delete this parameter?',
            ENTITY_TYPES: {
                MESSAGE_REMOVE: 'Are you sure you want to delete this parameter type?'
            },
            VALIDATION: {
                REQUIRED_FIELD: 'Required field',
                MIN_LENGTH_FIELD: 'Minimum field length:',
                MAX_LENGTH_FIELD: 'Maximum field length:',
                INVALID_DATE_RANGE: 'Invalid date range.',
                NOT_RECORDS_FOUND: 'No records found.'
            }
        },
        MODAL_CONFIRMATION: {
            CONFIRM_DELETE: 'Confirm Delete',
            CONFIRM_CANCEL: 'Confirm Cancel', 
            CONFIRM_ADD: 'Confirm Action',
            CONFIRM_ROLLBACK: 'Confirm Rollback',
            CONFIRM_CLOSE: 'Confirm Close',
			CONFIRM_SEND: 'Confirm Send Prebooks',
			CONFIRM_RELOCATE: 'Confirm Relocate',
            ACCEPT: 'Accept',
            CANCEL: 'Cancel',
        },
        MESSAGES: {
            VALIDATION: {
                REQUIRED_FIELD: 'Required field',
                INVALID_DATE_RANGE: 'Invalid date range.',
                NOT_RECORDS_FOUND: 'No records found.'
            }
        },
        PO: {
            ALERT_FILL_FIELDS_LOT_NUMBER: 'Please fill the Warehouse field and the Part Code field before Lot Number',
            ALERT_FILL_WAREHOUSE_FOR_PART_CODE: 'Please fill the Warehouse field before Part Code',
            PO_ORDER_CREATION: {
                CREATE_ORDER: 'Create Order(s)',
                UPDATE_ORDER: 'Update Order(s)'
            },
            BUYER_PART_NUMBER: 'Buyer Part Code',
            VENDOR_PART_NUMBER: 'Vendor Part Code',
            UPC_CASE_CODE: 'UPC Code',
            CONSUMER_PACKAGE_CODE: 'Consumer Code',
            GTIN: 'GTIN'
        },
        PROCESSING: {
            CHANGE_SALES_ORDER: {
                TITLE_COMPONENT: 'Change/Assign PO Number',
                ORDER_ALREADY_CONFIRMED: 'This order is already confirmed in Ross, please contact your system administrator',
                ORDER_WITHOUT_PO_UNPROCESSED: 'No Unprocessed PO Available',
                WITHOUT_SALE_ORDER: 'No records found',
                PO_NOT_FOUND: 'PO number doesn\'t exists.',
				SUBTITLE_CHANGE_COMPONENT: 'Change PO Number in Sales Order',
				SUBTITLE_ASSIGN_COMPONENT: 'Assign PO Number to Sales Order',
            },
            CANCEL_SALES_ORDER: {
                TITLE_COMPONENT: 'Cancel Sales Order',
                ORDER_ALREADY_CONFIRMED: 'This order is already confirmed in Ross, please contact your system administrator',
                ORDER_WITHOUT_PO_UNPROCESSED: 'No Unprocessed PO Available',
                WITHOUT_SALE_ORDER: 'No records found',
                PO_NOT_FOUND: 'PO number doesn\'t exists.',
                PO_CANCELED: 'PO associated to the order is already cancelled'
            }
        },
        VESSELS: {
            VESSELS: {
                MESSAGE_REMOVE: 'Are you sure you want to delete this vessel?'
            },
            VALIDATION: {
                REQUIRED_FIELD: 'Required field',
                MIN_LENGTH_FIELD: 'Minimum field length:',
                MAX_LENGTH_FIELD: 'Maximum field length:',
                INVALID_DATE_RANGE: 'Invalid date range.',
                NOT_RECORDS_FOUND: 'No records found.'
            }
        },
        LOADINGPORT: {
            LOADINGPORT: {
                MESSAGE_REMOVE: 'Are you sure you want to delete this Loading Port?'
            },
            VALIDATION: {
                REQUIRED_FIELD: 'Required field',
                MIN_LENGTH_FIELD: 'Minimum field length:',
                MAX_LENGTH_FIELD: 'Maximum field length:',
                INVALID_DATE_RANGE: 'Invalid date range.',
                NOT_RECORDS_FOUND: 'No records found.'
            }
        },
        SCHEDULE: {
            SCHEDULE: {
                MESSAGE_REMOVE: 'Are you sure you want to delete this Schedules?',
                MESSAGE_CLOSE: 'Are you sure you want to close all Schedules for this Due Date?'
            },
            VALIDATION: {
                REQUIRED_FIELD: 'Required field',
                MIN_LENGTH_FIELD: 'Minimum field length:',
                MAX_LENGTH_FIELD: 'Maximum field length:',
                INVALID_DATE_RANGE: 'Invalid date range.',
                NOT_RECORDS_FOUND: 'No records found.'
            }
        },
        ORDER: {
            ORDER: {
                MESSAGE_REMOVE: 'Are you sure you want to delete this Order?'
            },
            VALIDATION: {
                REQUIRED_FIELD: 'Required field',
                MIN_LENGTH_FIELD: 'Minimum field length:',
                MAX_LENGTH_FIELD: 'Maximum field length:',
                INVALID_DATE_RANGE: 'Invalid date range.',
                NOT_RECORDS_FOUND: 'No records found.'
            }
        },
        PREBOOKLINE: {
            PREBOOKLINE: {
                MESSAGE_REMOVE: 'Are you sure you want to delete this Prebook Line?',
				MESSAGE_SEND: 'Are you sure you want to Send this Prebooks?'
            },
            VALIDATION: {
                REQUIRED_FIELD: 'Required field',
                MIN_LENGTH_FIELD: 'Minimum field length:',
                MAX_LENGTH_FIELD: 'Maximum field length:',
                INVALID_DATE_RANGE: 'Invalid date range.',
                NOT_RECORDS_FOUND: 'No records found.'
            }
        },
        PREBOOK: {
            PREBOOK: {
                MESSAGE_VALIDATION: 'You must enter all the search parameters'
            },
            VALIDATION: {
                REQUIRED_FIELD: 'Required field',
                MIN_LENGTH_FIELD: 'Minimum field length:',
                MAX_LENGTH_FIELD: 'Maximum field length:',
                INVALID_DATE_RANGE: 'Invalid date range.',
                NOT_RECORDS_FOUND: 'No records found.'
            }
        },
        OPERATIONS: {
            HARMONIZED_TARIFF: {
                SUCCESS_DELETE: 'Tariff Successfully Deleted',
                SUCCESS_REGISTER: 'Tariff Successfully Registered',
                MESSAGE_REMOVE: 'Are you sure you want to delete this tariff?',
                ERROR_REGISTER: 'Error: Cannot register the customer addresses, please contact your administrator',
                ERROR_DELETE: 'Error: Cannot delete the customer addresses, please contact your administrator',
                VALIDATION: {
                    TARIFF: 'PLEASE USE TARIFF FORMAT ####.##.####'
                }
            },
            WAREHOUSE_CONTACT: {
                SUCCESS_UPDATE: 'Warehouse Contact Successfully Updated',
                SUCCESS_DELETE: 'Warehouse Contact Successfully Deleted',
                SUCCESS_REGISTER: 'Warehouse Contact Successfully Registered',
                MESSAGE_REMOVE: 'Are you sure you want to delete this warehouse contact?',
                ERROR_REGISTER: 'Error: Cannot register the warehouse contact, please contact your administrator',
                ERROR_UPDATE: 'Error: Cannot update the warehouse contact, please contact your administrator',
                ERROR_DELETE: 'Error: Cannot delete the warehouse contact, please contact your administrator'
            },
			WAREHOUSE_LOCATION: {
                MESSAGE_REMOVE: 'Are you sure you want to delete this warehouse location?'
            },
			WAREHOUSE_DOORS: {
                MESSAGE_REMOVE: 'Are you sure you want to delete this warehouse door?'
            },
			FILE_RECORD: {
                SUCCESS_UPDATE: 'File Record Successfully Updated',
                SUCCESS_DELETE: 'File Record Successfully Deleted',
                SUCCESS_REGISTER: 'File Record Successfully Registered',
                MESSAGE_REMOVE: 'Are you sure you want to delete this File Record?',
                ERROR_REGISTER: 'Error: Cannot register the File Record, please contact your administrator',
                ERROR_UPDATE: 'Error: Cannot update the File Record, please contact your administrator',
                ERROR_DELETE: 'Error: Cannot delete the File Record, please contact your administrator'
            },
			FILE_FIELD: {
                SUCCESS_UPDATE: 'Field Successfully Updated',
                SUCCESS_DELETE: 'Field Successfully Deleted',
                SUCCESS_REGISTER: 'Field Successfully Registered',
                MESSAGE_REMOVE: 'Are you sure you want to delete this Field?',
                ERROR_REGISTER: 'Error: Cannot register the Field, please contact your administrator',
                ERROR_UPDATE: 'Error: Cannot update the Field, please contact your administrator',
                ERROR_DELETE: 'Error: Cannot delete the Field, please contact your administrator'
            },
			FILE_MAPPING: {
                SUCCESS_UPDATE: 'Field Mapping Successfully saved',
                SUCCESS_DELETE: 'Field Mapping Successfully Deleted',
                SUCCESS_REGISTER: 'Field Mapping Successfully Saved',
                MESSAGE_REMOVE: 'Are you sure you want to delete this Field Mapping?',
                ERROR_REGISTER: 'Error: Cannot save the Field Mapping, please contact your administrator',
                ERROR_UPDATE: 'Error: Cannot update the Field Mapping, please contact your administrator',
                ERROR_DELETE: 'Error: Cannot delete the Field Mapping, please contact your administrator'
            }
        },
        TRUCK_RECEIPT: {
            WAREHOUSE_ACCESS_DENIED: 'You have no access to Truck Receipts for warehouse {{warehouse}}.',
            EMAIL: {
                REGISTERED_EMAILS: 'Registered email(s)',
                OTHER_EMAILS: 'Other Email(s)',
                NO_MAIL_SELECTED: 'Please select or write a valid email',
                NO_EMAILS_FOUND: 'No emails found',
                INVALID_EMAIL: 'Invalid email Address.',

            },
        },
		CONTAINER_SEARCH: {
			VALIDATION: {
				YEAR_MIN: "The year cannot be less than 2019.",
				YEAR_MAX: "The year cannot be greater than the current year.",
				WEEK_MIN: "The week cannot be zero or a negative number.",
				WEEK_MAX: "The year cannot be greater than 53.",
			}
		},
		CONTAINER_REPORT: {
			NO_ENTITIES: "You have no access to container locations. Please contact your administrator.",
			NO_PRODUCTCLASS: "You have no access to product Classes. Please contact your administrator.",
			ADD_COMMENT: "Successfully registered",
			REQUIRED_FIELD: 'Required field',
			MESSAGE_RELOCATE: 'Are you sure you want to Relocate this Container?',
			TOOLTIP_GROUP_BY_COLUMN: 'Group table rows by this column',
			TOOLTIP_FILTER_COLUMN: 'Filter rows by values in this column',
		},
		PALLET_CONTAINER_SEARCH: {
			VALIDATION:{
				PALLET_NUMBER_20_CHARACTERS: "The pallet number must have exactly 20 characters.",
				ONLY_NUMBERS: "The pallet number should be numeric.",
			}
		},
		COS:
		{
			MESSAGE_REMOVE: 'Are you sure you want to delete this Product Price?',
			VALIDATION_PRICE: 'Must be greater than 0'
		},
        DOCK_DOOR: {
            VALIDATION_DOOR: 'There are no doors for the selected warehouse.',
            SUCCESS_DOOR: 'Door assigned successfully.',
            NOT_SUCCESS_DOOR: 'The door could not be assigned correctly.',
            ORDER_NOT_EXISTS: 'Order does not exist. Contact your supervisor.',
            ORDER_NOT_CONFIRMED: 'Order not planned in the portal. Contact your supervisor.',
            ORDER_NOT_ASSIGNED: 'The order has not been assigned to any door. Inspection cannot be carried out.',
            NO_PERMITS: 'You do not have permissions to assign entry or exit doors in this warehouse.'
        },
        CUSTOMER_STATEMENT_MESSAGE: {
            SUCCESS: 'Message saved successfully',
            DELETE_MESSAGE: 'Are you sure you want to delete this message?',
        },
        CNC: {
            CNC: {
                MESSAGE_REMOVE: 'Are you sure you want to delete this record ?',
                MESSAGE_SOURCE_RESET: 'Changing this parameter will reset the form, do you want to proceed? And present the empty form only',
                MESSAGE_REMOVE_COMPLAINT: 'Are you sure you want to cancel this complaint?',
                MESSAGE_RESET: 'Changing this option will reset the form, do you want to proceed? And present the empty form only',
                MESSAGE_ADD: 'There is information in the table without a checkbox selected, which will not be added. Do you want to proceed?',
                MESSAGE_ROLLBACK_TODO: 'Are you sure you want to revert this process?',
            },
            VALIDATION: {
                REQUIRED_FIELD: 'Required field',
                MIN_LENGTH_FIELD: 'Minimum field length:',
                MIN_LENGTH_FIELD_DESCRIPTION: 'Below min. Length 50 char.',
                MAX_LENGTH_FIELD: 'Maximum field length:',
                INVALID_DATE_RANGE: 'Invalid date range.',
                NOT_RECORDS_FOUND: 'No records found.',
                NO_NEGATIVE_NUMBERS_QUANTITY: 'Cannot be zero or negative',
                NO_NEGATIVE_PRICE: 'Cannot be zero or negative',
                SUM_EXCEEDED: 'Sum exceeds ordered qty.',
                MAX_LENGTH_PRICE: 'Exceeds order price.',
                AT_LEAST_ONE_OPTION_REQUIRED: 'At least one option must be selected.',
                INVALID_EMAIL: 'The email is not valid.',
                MINIMUM_VALUE: 'Cannot be negative',
                GL_ACCOUNT_REQUIRED: 'GL Account Number is required',
                GL_ACCOUNT_PATTERN: 'Must be exactly 6 digits'
            }
        },
    }
};

